import { Flex, Typography } from 'antd';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '@/shared/lib/hooks';

export function AuthLayout() {
  const { t } = useTranslation();
  const { isMobile } = useBreakpoint();

  return (
    <Flex
      align="center"
      justify="center"
      style={{ minHeight: '100vh', padding: 16, background: 'var(--color-bg-layout)' }}
    >
      <Flex
        vertical
        gap={24}
        style={{
          width: '100%',
          maxWidth: 400,
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          padding: isMobile ? 24 : 32,
          borderRadius: 'var(--radius-container)',
        }}
      >
        <Typography.Title
          level={3}
          style={{ margin: 0, textAlign: 'center', color: 'var(--color-primary)' }}
        >
          {t('app.name')}
        </Typography.Title>
        <Outlet />
      </Flex>
    </Flex>
  );
}
